export const enTranslations = {
  "site.name": "CSSBuyBR",
  "site.tagline": "Independent Resource for CSSBuy Spreadsheet",
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.guides": "Guides",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.qc": "QC",
  "nav.sellers": "Sellers",
  "nav.safety": "Safety",
  "lang.pt": "PT-BR",
  "lang.de": "DE",
  "lang.en": "EN",
  "hero.title": "CSSBuy Spreadsheet: Find Products, Sellers & Buying Resources with Ease",
  "hero.subtitle": "Explore an independent and updated guide to research products, compare sellers, understand QC information, evaluate shipping options and make more informed buying decisions with CSSBuy Spreadsheet.",
  "hero.cta.primary": "Explore CSSBuy Spreadsheet",
  "hero.cta.secondary": "View Complete Guide",
  "hero.trust": "Independent Guides • Practical Comparisons • Updated Resources",
  "categories.title": "Product Categories",
  "categories.subtitle": "Select a category to explore products on CSSBuy Spreadsheet",
  "categories.dropdown.placeholder": "Select a category...",
  "cta.mainSite": "CSSBuy Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.explore": "Explore All CSSBuy Resources",
  "intro.title": "What is CSSBuy Spreadsheet?",
  "intro.text": "CSSBuy Spreadsheet is a practical way to organize information about products, sellers, prices, categories and research resources before making a purchase. It helps you compare different options more systematically and find relevant information faster.",
  "resources.title": "Find Important Information in One Place",
  "resources.products": "Products",
  "resources.products.desc": "Search and organize products by category.",
  "resources.sellers": "Sellers",
  "resources.sellers.desc": "Compare sellers and available information.",
  "resources.qc": "QC",
  "resources.qc.desc": "Understand how to analyze quality photos and information.",
  "resources.shipping": "Shipping",
  "resources.shipping.desc": "Compare shipping methods and costs.",
  "resources.warehouse": "Warehouse",
  "resources.warehouse.desc": "Understand the storage and preparation process.",
  "resources.safety": "Safety",
  "resources.safety.desc": "Learn to identify risks and suspicious information.",
  "compare.title": "Compare Before You Buy",
  "compare.factor": "Factor",
  "compare.check": "What to Check",
  "compare.why": "Why It Matters",
  "compare.product": "Product",
  "compare.product.check": "Description and variants",
  "compare.product.why": "Avoids mistakes",
  "compare.seller": "Seller",
  "compare.seller.check": "History and reviews",
  "compare.seller.why": "Helps research",
  "compare.qc": "QC",
  "compare.qc.check": "Available photos",
  "compare.qc.why": "Allows detail verification",
  "compare.price": "Price",
  "compare.price.check": "Different options",
  "compare.price.why": "Facilitates comparison",
  "compare.shipping": "Shipping",
  "compare.shipping.check": "Method and cost",
  "compare.shipping.why": "Helps planning",
  "articles.title": "Articles & Guides",
  "articles.subtitle": "Original and updated content about CSSBuy Spreadsheet",
  "articles.readMore": "Read full article",
  "footer.disclaimer": "This website is an independent informational resource. It is not the official CSSBuy website unless explicitly stated.",
  "footer.copyright": "© 2026 CSSBuyBR Guru. All rights reserved.",
  "footer.about": "About",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.disclaimerLink": "Disclaimer",
  "footer.safety": "Safety Center",
  "footer.editorial": "Editorial Policy",
  "seo.homeTitle": "CSSBuy Spreadsheet: Complete Product & Seller Guide 2026",
  "seo.homeDesc": "CSSBuy Spreadsheet independent resource. Find products, compare sellers, understand QC, shipping and warehouse. Practical and updated guides.",
  "article.published": "Published",
  "article.updated": "Updated",
  "article.author": "CSSBuyBR Team",
  "article.breadcrumbHome": "Home",
  "article.related": "Related Articles",
  "article.toc": "Contents",
  "article.quickAnswer": "Quick Answer",
  "safety.notice": "This website is an independent informational resource. It is not the official CSSBuy website unless explicitly stated. Always verify prices, policies, sellers, links, payment methods and shipping conditions before making a purchase.",
  "notFound.title": "Page Not Found",
  "notFound.back": "Back to Home",
  "schema.orgName": "CSSBuyBR Guru",
  "schema.orgDesc": "Independent resource for CSSBuy Spreadsheet, products, sellers and buying guides"
};

export default enTranslations;